import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Lets any header (dashboard, project) open the shared Edit Profile sidebar,
// which is mounted once at the app root.
@Injectable({ providedIn: 'root' })
export class PortalProfileService {

	private openSource = new Subject<void>();
	open$ = this.openSource.asObservable();

	open(): void {
		this.openSource.next();
	}
}
